import React from 'react'
import "./login-sidebar.scss";
const LoginSidebarComponent = () => {
  return (
   <>
    <div className="login-left-side h-100 d-flex flex-column justify-content-between p-4 overflow-lg-auto">
            <div>
              <img
                src="../../assets/images/FM-logo-white.svg"
                alt=""
                className="fm-logo"
              />
            </div>

            <img
              src="../../assets/images/theme-bg.svg"
              alt=""
              className="shield-icon"
            />
            <div>
              <h4 className="fs-46 fw-600 text-white m-0 pb-3 fs-46-sm">
                Manage <br />
                and Track Your <br /> Finances with Ease
              </h4>
              <p className="fs-16 fw-400 text-warning m-0">
              Your finances, made easy!
              </p>
            </div>
          </div></>
  )
}

export default LoginSidebarComponent